import React from "react";
import Textarea from "../components/primatives/Textarea";
import Input from "../components/primatives/Input";

class ShowCredentials extends React.Component {
  render() {
    const { username, privateKey } = this.props;

    return (
      <div>
        <div className="text-sm mb-1 font-bold">Username:</div>
        <Input readOnly={true} bgColor="bg-transparent" value={username} />
        <div className="mb-2" />
        <div className="text-sm mb-1 font-bold">Password / Key:</div>
        <Textarea readOnly={true} bgColor="bg-transparent" value={privateKey} />
        <div className="text-xs mt-1">Credentials <i>disappear</i> when you're logged out.</div>
      </div>
    );
  }
}

export default ShowCredentials;
